<template>
  <div>
    <f-button variant="link" modal-id="uvp-modal">
      <i class="fal fa-info-circle"></i>
    </f-button>
    <f-modal id="uvp-modal" title="Warum FAAREN?" ok-title="Alles klar!">
      <p>
        <i class="fal fa-check text-success"></i> <strong>Alles inklusive außer Sprit</strong><br>
        Bei uns ist alles im monatlichen Festpreis mit drin. Du bezahlst selbst also nur noch den Sprit. Sogar Reparaturen!
      </p><br>
      <p>
        <i class="fal fa-check text-success"></i> <strong>Wechsle oder Kündige monatlich</strong><br>
        Je nach deinem Bedürfniss kannst du bei uns dein Auto komplett flexibel abonnieren oder eine längere Mindestlaufzeit wählen und sparen.
      </p>
      <p>
        <i class="fal fa-check text-success"></i> <strong>Deutschlandweite Lieferung / Abholung</strong><br>
        Ganz wie du willst: Lass dir dein Auto bequem an die Arbeit oder nach Hause liefern - oder hol es ohne Mehrkosten selbst beim Händler ab.
      </p>
    </f-modal>
  </div>
</template>
<script>
import {
  FButton, FModal
} from "faaren-ui";

export default {
  name: "UVPModal",
  components: {
    FButton, FModal
  },
}
</script>
<style lang="scss">
</style>
